const FALLBACK_OPTIONS_BY_FIELD = {
  jobRemoteStatus: ['On-Site', 'Remote', 'Hybrid'],
  jobRecruitmentStatus: ['unread', 'partially fulfilled', 'fulfilled'],
  'experience.experienceRequiredUnit': ['Years', 'Months'],
  'contractDuration.unit': ['Days', 'Weeks', 'Months', 'Years'],
  noticePeriodUnit: ['Days', 'Weeks', 'Months'],
  'jobPayDetails.clientBudgetCurrency': ['$', 'USD', 'INR'],
  'jobPayDetails.clientBudgetUnit': ['Hour', 'Daily', 'Monthly', 'Yearly'],
  workAuthorisation: ['US Citizen', 'Green Card', 'H1B', 'OPT', 'CPT', 'L2 EAD', 'H4 EAD', 'Other'],
  relocation: ['Yes', 'No'],
  source: ['LinkedIn', 'Referral', 'Dice', 'Indeed', 'Monster', 'Vendor', 'Other'],
};

export function getEditFormFallbackOptions(field = {}) {
  return FALLBACK_OPTIONS_BY_FIELD[field.field] ?? [];
}
